module.exports = __webpack_public_path__ + "img/dosti91.93279f19.svg";